import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Layout, InputNumber } from "antd";
import { useNavigate } from "react-router";
import { Post } from "../../config/api/post";
import { Get } from "../../config/api/get";
import { RATES, COMISSSION } from "../../config/constants/api";
import swal from "sweetalert";
import { FaArrowLeft } from "react-icons/fa";
import "../profile/profile.css";
import "./rates.css";

const navItems = [
  { label: "Profile", path: "/profile" },
  { label: "Education", path: "/education" },
  { label: "Meetings", path: "/meetings" },
  { label: "Subjects", path: "/subjects" },
  { label: "Services", path: "/services" },
  { label: "Hourly Rates", path: "/rates" },
  { label: "Rating & Review", path: "/review" },
  { label: "My Meetings", path: "/my-meetings" },
  { label: "My Assesments", path: "/my-assesments" },
];

function Rates() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [rates, setRates] = useState({
    hourlyRate: 0,
    tutoringRate: 0,
    coachingRate: 0,
  });
  const [savedRates, setSavedRates] = useState({
    hourlyRate: 0,
    tutoringRate: 0,
    coachingRate: 0,
  });
  const [comissions, setComissions] = useState({
    coachingCommission: 0,
    tutoringCommission: 0,
  });
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (user) {
      getMyRates();
      getComissions();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getMyRates = () => {
    try {
      Get(RATES?.getMyRates, token).then((response) => {
        if (response?.status) {
          setRates(response?.data?.rates);
          setSavedRates(response?.data?.rates);
        } else {
          console.log("response", response);
        }
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  const getComissions = () => {
    try {
      Get(COMISSSION.getComission, token).then((response) => {
        if (response?.status) {
          setComissions(response?.data);
        } else {
          console.log("response", response);
        }
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  const updateRates = () => {
    setLoading(true);

    if (!rates?.hourlyRate || !rates?.hourlyRate || !rates?.hourlyRate) {
      setLoading(false);
      swal("Oops!", "rates cannot be zero", "error");
      return;
    }

    let data = {
      coachId: user._id,
      ...rates,
    };

    Post(RATES?.setRates, data, token, null)
      .then((response) => {
        setLoading(false);
        if (response?.data?.status) {
          console.log(response?.data);
          swal("Success!", "Rates Updated Successfully", "success");
          setLoading(false);
          setSavedRates(rates);
          setEditMode(false);
        } else {
          swal("Oops!", response.data.message, "error");
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <Layout className="profile-page">
      <section className="profile-hero">
        <div className="profile-wrap profile-hero-inner">
          <button
            type="button"
            className="rates-back"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <FaArrowLeft />
            Back
          </button>
          <h1 className="fontFamily1 profile-hero-title">Hourly Rates</h1>
          <p className="fontFamily1 profile-hero-sub">
            Set your hourly rates and review platform commission details.
          </p>
        </div>
      </section>

      <div className="profile-wrap profile-main">
        <div className="profile-layout">
          <aside className="profile-nav">
            <p className="profile-nav-title">Account</p>
            <ul className="profile-nav-list">
              {navItems.map((item) => (
                <li key={item.path}>
                  <button
                    type="button"
                    className={`profile-nav-item${
                      item.path === "/rates" ? " is-active" : ""
                    }`}
                    onClick={() => navigate(item.path)}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </aside>

          <section className="profile-panel">
            <div className="profile-panel-head">
              <div>
                <h2 className="fontFamily1 profile-panel-title">Rates</h2>
                <p className="profile-panel-sub">
                  {editMode
                    ? "Update your hourly rates, then save your changes."
                    : "Your current hourly rates for training and consulting."}
                </p>
              </div>
            </div>

            <div className="rates-grid">
              <div className="rates-card">
                <p className="rates-card-label">Average Hourly Rates</p>
                {!editMode ? (
                  <p className="rates-card-value">
                    $ {rates?.hourlyRate} / Hour
                  </p>
                ) : (
                  <InputNumber
                    style={{ width: "100%" }}
                    size="large"
                    value={rates?.hourlyRate}
                    onChange={(e) => setRates({ ...rates, hourlyRate: e })}
                    formatter={(value) =>
                      `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    placeholder="Enter salary"
                    className="signupFormInput signupSelectBox"
                  />
                )}
              </div>

              <div className="rates-card">
                <p className="rates-card-label">Training Hourly Rates</p>
                {!editMode ? (
                  <p className="rates-card-value">
                    $ {rates?.tutoringRate} / Hour
                  </p>
                ) : (
                  <InputNumber
                    style={{ width: "100%" }}
                    size="large"
                    value={rates?.tutoringRate}
                    onChange={(e) => setRates({ ...rates, tutoringRate: e })}
                    formatter={(value) =>
                      `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    placeholder="Enter salary"
                    className="signupFormInput signupSelectBox"
                  />
                )}
              </div>

              <div className="rates-card">
                <p className="rates-card-label">Consulting Hourly Rates</p>
                {!editMode ? (
                  <p className="rates-card-value">
                    $ {rates?.coachingRate} / Hour
                  </p>
                ) : (
                  <InputNumber
                    style={{ width: "100%" }}
                    size="large"
                    value={rates?.coachingRate}
                    onChange={(e) => setRates({ ...rates, coachingRate: e })}
                    formatter={(value) =>
                      `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    placeholder="Enter salary"
                    className="signupFormInput signupSelectBox"
                  />
                )}
              </div>
            </div>

            <div className="profile-actions">
              {!editMode ? (
                <Button
                  type="primary"
                  className="profile-btn-primary"
                  onClick={() => setEditMode(true)}
                >
                  Edit Rates
                </Button>
              ) : (
                <>
                  <Button
                    type="primary"
                    className="profile-btn-primary"
                    loading={loading}
                    onClick={() => updateRates()}
                  >
                    {loading ? "Loading..." : "Update Rates"}
                  </Button>
                  <Button
                    className="profile-btn-ghost"
                    ghost
                    size="large"
                    onClick={() => {
                      setRates(savedRates);
                      setEditMode(false);
                    }}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>

            <div className="rates-commission">
              <div className="profile-panel-head">
                <div>
                  <h2 className="fontFamily1 profile-panel-title">
                    Commission
                  </h2>
                  <p className="profile-panel-sub">
                    Platform commission applied to your sessions.
                  </p>
                </div>
              </div>

              {comissions ? (
                <div className="rates-grid">
                  <div className="rates-card rates-card--muted">
                    <p className="rates-card-label">Consulting Commission</p>
                    <p className="rates-card-value">
                      {comissions?.coachingCommission} %
                    </p>
                  </div>
                  <div className="rates-card rates-card--muted">
                    <p className="rates-card-label">Training Commission</p>
                    <p className="rates-card-value">
                      {comissions?.tutoringCommission} %
                    </p>
                  </div>
                </div>
              ) : (
                <p className="rates-empty">No Comissions Set</p>
              )}
            </div>
          </section>
        </div>
      </div>
    </Layout>
  );
}

export default Rates;
